"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var BrandStore_1 = __importDefault(require("../../DreamCoat/BrandSetUp/BrandStore/BrandStore"));
var StylePermissionStore_1 = __importDefault(require("../../DreamCoat/Permissions/StylePermissionStore/StylePermissionStore"));
var UploadStore_1 = __importDefault(require("Common/Upload/UploadStore"));
var UploadService_1 = __importDefault(require("Common/Upload/UploadService"));
var RootDataStore_1 = require("../../DataStores/RootDataStore");
var InviteNewUserModal_1 = require("../InviteNewUserModal/InviteNewUserModal");
var OnboardingStore_1 = __importDefault(require("Onboarding/OnboardingStore"));
var OnboardingService_1 = require("Onboarding/OnboardingService");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Templater_1 = __importDefault(require("Project/Service/Templater"));
var MarkedTemplateExplainer_1 = __importDefault(require("Project/Actions/MarkedTemplate/MarkedTemplateExplainer"));
var PageResourceApiService_1 = require("Dashboard/ProjectList/PageResourceApiService");
var QwilrConfig = window.QwilrConfig;
module.exports = function ($state, user, userList, stripeKey, projectCount, projectLiveCount, featureFlags, tags, tourState) {
    var Emitter = require("events").EventEmitter;
    var maker = function (constructor, extraArgs) {
        if (extraArgs === void 0) { extraArgs = {}; }
        return function (make) { return make(constructor, extraArgs); };
    };
    var invoker = function (func, extraArgs, context) {
        if (extraArgs === void 0) { extraArgs = {}; }
        return function (invoke) { return invoke(func, context, extraArgs); };
    };
    var injectables = {
        mountReactComponent: require("MountReactComponent/MountReactComponent").default,
        colorPalette: require("Common/ColorPicker/ColorPalette").ColorPalette,
        currencies: require("@CommonFrontendBackend/Quote/Models/Currencies"),
        currenciesList: maker(require("Project/Service/CurrenciesList").default),
        QwilrStripe: stripeKey,
        featureFlags: featureFlags,
        environment: QwilrConfig.environment || "production",
        primaryDomain: QwilrConfig.primaryDomain,
        genericHost: QwilrConfig.genericHost,
        apiBaseUrl: QwilrConfig.apiBaseUrl,
        thumbnailApiBaseUrl: QwilrConfig.thumbnailApiBaseUrl,
        vaultUrl: QwilrConfig.vaultUrl,
        publicApiBaseUrl: QwilrConfig.publicApiBaseUrl,
        clientUrl: QwilrConfig.clientUrl,
        stripeClientId: QwilrConfig.stripeClientId,
        alfredApiBaseUrl: QwilrConfig.alfredApiBaseUrl,
        googleFontsApiKey: QwilrConfig.googleFontsApiKey,
        pusherAppKey: QwilrConfig.pusherAppKey,
        userFilesUrl: QwilrConfig.userFilesUrl,
        bluePrintBatchLimit: QwilrConfig.bluePrintBatchLimit,
        segmentDisabled: QwilrConfig.segmentDisabled,
        fingerprintPublicKey: QwilrConfig.fingerprintPublicKey,
        errorCodes: require("@CommonFrontendBackend/ErrorCodes/ErrorCodes").ErrorCodes,
        templateMetadata: require("Metadata/Metadata").templateMetadata,
        companyTypes: require("Metadata/Metadata").companyTypes,
        promptOrchestrator: function (rootDataStore, usingFeature) {
            return new (require("Common/Prompt/PromptOrchestrator").PromptOrchestrator)(rootDataStore.userDataStore.useHistoryDataStore, usingFeature);
        },
        navigationHeaderHeight: 60,
        appDomSelector: ".top-level-view",
        utils: require("Common/Utils/Utils"),
        noop: function () {
            return function () { };
        },
        state: maker(require("Common/State/State").default),
        persist: function () {
            return require("Common/Persist/Persist");
        },
        persistenceTracker: maker(require("Common/Persist/PersistenceTracker").default),
        scrollToElement: require("Common/Utils/ScrollTo"),
        keyboard: maker(require("Utils/Keyboard")),
        cleanJson: function () {
            return require("CleanJson/CleanJson").default;
        },
        tether: invoker(require("Common/Tether/Tether")),
        tetherTracker: maker(require("Common/Tether/TetherTracker")),
        Sequencer: function () {
            return require("Common/Utils/Sequencer");
        },
        waitFor: invoker(require("Common/Utils/WaitFor")),
        blockUtils: require("@CommonFrontendBackend/Utils/BlockUtils"),
        iframeGenerator: maker(require("Common/Iframe/Generator")),
        videoEmbedUrlGenerator: maker(require("@CommonFrontendBackend/Video/EmbedUrlGenerator").default),
        stringManipulater: require("Utils/StringManipulater").default,
        getFullName: function () {
            return require("@CommonFrontendBackend/Utils/GetFullName").default;
        },
        getInitials: function () {
            return require("Utils/GetInitials").getInitialsFromUser;
        },
        createLoadingController: require("LoadingController/LoadingController"),
        uniqueId: function () {
            return require("@CommonFrontendBackend/Utils/UniqueId").default;
        },
        trial: maker(require("Common/TrialAngular/Trial")),
        createTrialMessage: require("Common/TrialAngular/CreateTrialMessage"),
        pusher: require("Common/Pusher/Pusher"),
        account: user.account,
        accountQuoteSettings: user.account.settings.modules.quote,
        brandStore: function (account, modal, telemetry, apiBaseUrl, styleWorker) {
            return new BrandStore_1.default(account, modal, telemetry, apiBaseUrl, styleWorker);
        },
        user: user,
        userList: userList,
        initialProjectCount: projectCount,
        projectLimitFactory: require("Common/ProjectLimit/ProjectLimit"),
        projectLimit: function (projectLimitFactory) {
            return projectLimitFactory.createProjectLimit();
        },
        projectLiveLimit: function (projectLimitFactory) {
            return projectLimitFactory.createProjectLiveLimit();
        },
        projectCounter: maker(require("Common/ProjectCounter/ProjectCounter")),
        projectLiveCounter: maker(require("Common/ProjectCounter/ProjectCounter"), {
            initialProjectCount: projectLiveCount,
        }),
        projectTags: tags,
        notificationTypes: require("Common/NotificationTypes/NotificationTypes"),
        domFrame: maker(require("Common/DomFrame/DomFrame")),
        overlayStack: maker(require("OverlayStack/OverlayStack.js")),
        OverlayStackCard: function () {
            return require("OverlayStack/OverlayCard/OverlayCard");
        },
        ColorSelector: function () {
            return require("Common/AtomicUI/ColorSelector/ColorSelector");
        },
        modalAngular: maker(require("Common/ModalAngular/Modal")),
        showAcknowledgeModal: invoker(require("Common/ModalAngular/AcknowledgeModal/AcknowledgeModal")),
        showDecideModal: invoker(require("Common/ModalAngular/DecideModal/DecideModal").default),
        showDeleteModal: invoker(require("Common/ModalAngular/DeleteModal/DeleteModal").default),
        styleModalService: invoker(require("Common/ModalAngular/StyleModals/StyleModalService").default),
        notifyUser: maker(require("Common/NotifyUser/NotifyUser").default),
        dropdown: function () {
            return require("Common/Dropdown/Dropdown");
        },
        savingIndicator: maker(require("Common/SavingIndicator/SavingIndicator")),
        MenuDropdown: function () {
            return require("Common/AtomicUI/MenuDropdown/MenuDropdown");
        },
        undoNotifier: maker(require("Common/AtomicUI/Undo/Undo")),
        VideoBackground: require("VideoBackground/VideoBackground"),
        Button: require("CommonUI/Button/Button").default,
        AsyncButton: require("CommonUI/Button/AsyncButton").default,
        ActiveButton: require("CommonUI/Button/ActiveButton").default,
        BackButton: require("Common/AtomicUI/BackButton/BackButton").default,
        Search: require("CommonUI/Search/Search").default,
        EditableHeading: require("CommonUI/EditableHeading/EditableHeading").default,
        ActionButton: function () {
            return require("Common/AtomicUI/ActionButton/ActionButton");
        },
        RadioButtons: require("Common/AtomicUI/RadioButtonsAngular/RadioButtons").default,
        UserSelector: function () {
            return require("Common/AtomicUI/UserSelector/UserSelector");
        },
        OnClickOutside: function () {
            return require("CommonUI/OnClickOutside/OnClickOutside").default;
        },
        Link: function () {
            return require("Common/AtomicUI/Link/Link");
        },
        Slider: function () {
            return require("CommonUI/Slider/Slider");
        },
        simpleDropdownFactory: maker(require("CommonUI/SimpleDropdown/SimpleDropdown")),
        multiSelectDropdownFactory: maker(require("CommonUI/MultiSelectDropdown/MultiSelectDropdown")),
        concentricSpinner: invoker(require("CommonUI/ConcentricSpinner/ConcentricSpinner")),
        placeholderBlockFactory: maker(require("Common/PlaceholderBlock/PlaceholderBlockFactory")),
        OperationsChannel: function () {
            return require("Common/OperationsChannel/OperationsChannel").OperationsChannel;
        },
        Previewer: require("Common/Previewer/Previewer").default,
        userIconFactory: maker(require("UserIcon/UserIcon")),
        CarouselHandler: function () {
            return require("Common/CarouselAngular/CarouselHandler");
        },
        MediaCarousel: function () {
            return require("Common/CarouselAngular/MediaCarousel");
        },
        StyleCarousel: function () {
            return require("Common/CarouselAngular/StyleCarousel");
        },
        getTemplateUseCase: require("Common/AtomicUI/TemplateUseCase/TemplateUseCase").default,
        singleSignOn: invoker(require("CommonUI/SingleSignOn/SingleSignOn").default),
        Input: invoker(require("CommonUI/InputAngular/Input").default),
        SignupForm: invoker(require("CommonUI/SignupForm/SignupForm").default),
        mediaBrowser: maker(require("Common/MediaBrowser/MediaBrowser")),
        assetLibraryLauncher: require("Common/AssetLibrary/AssetLibrary").attachAssetLibrary,
        assetLibraryOverlay: maker(require("Common/AssetLibrary/AssetLibraryOverlay").AssetLibraryOverlay),
        Tooltip: function () {
            return require("Tooltip/Tooltip");
        },
        manualTooltip: require("Utils/ManualTooltipTrigger"),
        hint: require("Tooltip/Hint/Hint").default,
        Panel: require("Tooltip/Panel/Panel").default,
        speechBubble: require("Tooltip/SpeechBubble/SpeechBubble").default,
        TypographySelector: function () {
            return require("SettingsAngular/BrandSetup/Fonts/TypographySelector/TypographySelector");
        },
        fontService: maker(require("SettingsAngular/BrandSetup/Fonts/FontService")),
        GridPicker: function () {
            return require("Common/GridPicker/GridPicker");
        },
        ContextMenu: function () {
            return require("Common/ContextMenu/ContextMenu");
        },
        ImagePickerButton: function () {
            return require("Common/MediaPicker/ImagePicker/Button/Button");
        },
        Resizer: function () {
            return require("Common/Resizer/Resizer");
        },
        PdfExport: function () {
            return require("Project/Actions/PdfExport/PdfExport");
        },
        makeDraftLiveToggle: function () {
            return function (make, project, options) {
                return make(require("Project/Actions/DraftLiveToggle/DraftLiveToggle"), {
                    project: project,
                    options: options,
                });
            };
        },
        InviteUser: function () {
            return require("Common/AtomicUI/InviteUser/InviteUser");
        },
        InviteUserPopup: function () {
            return require("Common/AtomicUI/InviteUserPopup/InviteUserPopup");
        },
        loadingIndicator: maker(require("Common/Loading/Loading")),
        appEvents: new Emitter(),
        appViewState: {
            initialDataError: false,
            initialDataLoaded: false,
            navigation: {
                showNotifications: false,
                open: false,
                saving: false,
                notifySaved: false,
                serverError: false,
            },
            percentageOnboardingOpen: false,
            emailStateSnapshot: null,
        },
        loadFonts: invoker(require("Common/StyleWorker/LoadFonts")),
        loadFontsIntoBrowser: invoker(require("Common/StyleWorker/LoadFontsIntoBrowser")),
        styleWorker: maker(require("Common/StyleWorker/StyleWorker")),
        projectTagManagerModal: maker(require("Project/Actions/TagManager/TagManager")),
        projectStatusChecker: maker(require("Project/Service/StatusChecker")),
        projectLinkRetriever: maker(require("Project/Service/LinkRetriever").default),
        projectDeleter: maker(require("Project/Service/Deleter").default),
        projectRestorer: maker(require("Project/Service/Restorer").default),
        projectCreator: maker(require("Project/Service/Creator").default),
        projectStatusSetter: maker(require("Project/Service/StatusSetter").default),
        projectPreviewer: maker(require("Project/Service/Previewer")),
        projectSharer: maker(require("Project/Service/Sharer")),
        projectOpener: maker(require("Project/Service/Opener").ProjectOpener),
        projectSecurer: maker(require("Project/Service/Securer")),
        projectAnalyser: maker(require("Project/Service/Analyser").default),
        projectActions: maker(require("Project/Service/Actions/Actions").default),
        projectAuditInspector: maker(require("Project/Service/Audit/AuditInspector")),
        projectTagger: maker(require("Project/Service/Tagger")),
        projectTemplater: function (invoke, notifyUser, rootDataStore) {
            var useHistoryDataStore = rootDataStore.userDataStore.useHistoryDataStore;
            var showTemplateExplainer = function () { return invoke(MarkedTemplateExplainer_1.default); };
            return new Templater_1.default(showTemplateExplainer, useHistoryDataStore, notifyUser);
        },
        projectCollaborator: maker(require("Project/Service/Collaborator").default),
        projectTelemetry: require("Project/Service/Telemetry").default,
        projectPermissionsHandler: maker(require("Project/Service/PermissionsHandler")),
        projectService: require("Project/Service/Service"),
        pageCreationHelper: maker(require("../PageCreationHelper").PageCreationHelper),
        blockFetcher: maker(require("Blocks/BlockFetcher").BlockFetcher),
        teamsService: maker(require("Common/TeamsService/TeamsService").default),
        AccountTeamController: require("SettingsAngular/Team/AccountTeam/AccountTeamController").default,
        UserTeamsManager: require("SettingsAngular/Team/AccountTeam/UserTeamsManager").default,
        contract: maker(require("@CommonFrontendBackend/Utils/Contract")),
        accountService: maker(require("SettingsAngular/Account/Service/Service")),
        integrationFocusCreator: maker(require("SettingsAngular/Integrations/FocusCreator").default),
        SubdomainSetter: function () {
            return require("SettingsAngular/BrandSetup/Domains/SubdomainSetter/SubdomainSetter");
        },
        CustomDomainSetter: function () {
            return require("SettingsAngular/BrandSetup/Domains/CustomDomainSetter/CustomDomainSetter");
        },
        seatsService: maker(require("SettingsAngular/Subscription/Seats/SeatsService").default),
        bluePrintService: maker(require("Project/Actions/BluePrint/BluePrintService").default),
        imageService: maker(require("Common/ImageService/UnsplashImageService").default),
        recentlyUsedService: maker(require("Common/ImageService/RecentlyUsedService").default),
        mediaUsageReporter: maker(require("Common/ImageService/MediaUsageReporter").default),
        uploadsService: maker(require("Common/ImageService/UploadsService").UploadsService),
        stockImageService: maker(require("Common/ImageService/StockImagesService").default),
        imageResourceApiService: maker(require("Common/ImageService/ImageResourceApiService").ImageResourceApiService),
        telemetry: maker(require("Common/Telemetry/Telemetry").Telemetry),
        serverTelemetry: maker(require("Common/Telemetry/ServerTelemetry").default),
        initialiseFullstory: require("Common/Telemetry/InitialiseFullstory"),
        slack: function () {
            return require("Common/SlackMessenger/SlackMessenger");
        },
        internalSlack: function (make, slack) {
            return make(slack, {
                webhookUrl: "https://hooks.slack.com/services/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",
                defaultChannel: "#test",
                userName: "Dylan Robot Overlord",
            });
        },
        mobileBreakpoint: function (isPrintMode) {
            if (isPrintMode) {
                return 0;
            }
            else {
                return 750;
            }
        },
        isMobile: function (mobileBreakpoint) {
            return function () { return $(window).width() <= mobileBreakpoint; };
        },
        isPrintMode: invoker(require("Utils/IsPrintMode")),
        notReadyForMobile: maker(require("Common/NotReadyForMobile/NotReadyForMobile")),
        upseller: maker(require("Common/Upseller/Upseller")),
        upsellerService: maker(require("Common/Upseller/UpsellerService").default),
        makeUpsellTooltip: invoker(require("Common/UpsellTooltip/UpsellTooltip")),
        userHistory: maker(require("./UserHistory").default),
        formBuilder: maker(require("Common/FormBuilder/FormBuilder")),
        integrationService: maker(require("SettingsAngular/Integrations/Service").default),
        genericIntegration: maker(require("SettingsAngular/Integrations/GenericIntegration.js")),
        integrationInvoiceSettings: maker(require("SettingsAngular/Integrations/InvoiceSettings")),
        GenericInvoicer: function () {
            return require("Project/Modules/Quote/Accept/Invoicers/GenericInvoicer");
        },
        invoicerService: maker(require("Project/Modules/QuoteV2/Integrations/InvoicerService")),
        xero: maker(require("SettingsAngular/Integrations/Xero/XeroCommon.js")),
        freshbooksInvoicer: maker(require("SettingsAngular/Integrations/FreshBooks/FreshBooksInvoicer.js")),
        customLabels: maker(require("Project/Modules/QuoteV2/CustomLabels/CustomLabels")),
        labelService: maker(require("QuoteV2/Labels/LabelService").LabelService),
        variableService: maker(require("QuoteV2/Variables/VariableService").default),
        billingScheduleOrchestrator: maker(require("QuoteV2/BillingSchedule/BillingScheduleOrchestrator").BillingScheduleOrchestrator),
        discountService: maker(require("@CommonFrontendBackend/Discount/Discount.service").default),
        savedStyleService: maker(require("DreamCoat/SavedStyle/SavedStyleService/SavedStyleService").default),
        convertQuoteFromV1: function () {
            return require("QuoteV2/Models/ConvertFromV1")(lodash_1.default);
        },
        onboardingStore: function (user, userList, telemetry, serverTelemetry, overlayStack, mountReactComponent, apiBaseUrl, rootDataStore, account, environment, $rootScope, usingFeature, savedBlockService, projectService, isMobile, onboardingTelemetryService) {
            var userDataStore = rootDataStore.userDataStore;
            var accountDataStore = rootDataStore.getAccountDataStore();
            var useHistoryDataStore = userDataStore.useHistoryDataStore;
            var onboardingService = new OnboardingService_1.OnboardingService(mountReactComponent, overlayStack, apiBaseUrl, user, account, useHistoryDataStore, userList.length, $rootScope, usingFeature, savedBlockService, projectService, isMobile, onboardingTelemetryService, userDataStore, $state);
            return new OnboardingStore_1.default(onboardingService, userDataStore, useHistoryDataStore, accountDataStore);
        },
        onboardingTelemetryService: maker(require("Onboarding/OnboardingTelemetryService").default),
        styleService: maker(require("@CommonFrontendBackend/StyleService/StyleService")),
        emailTemplates: {
            library: null,
        },
        paymentService: maker(require("SettingsAngular/Subscription/CreditCard/PaymentService")),
        planService: maker(require("SettingsAngular/Subscription/PlanExplorer/PlanService")),
        permissionsService: maker(require("Common/Permissions/Service")),
        rolesService: maker(require("Common/Roles/Service").RolesService),
        attachQuoteAcceptToolbar: function () {
            return require("DreamCoat/StyleToolBar/attachQuoteAcceptToolbar");
        },
        addDefaultTcdcStyle: invoker(require("Project/Service/TCDCProjectConverter/AddDefaultStyle").default),
        stylePermissionStore: function (usingFeature, rolesService) {
            return new StylePermissionStore_1.default(user.account, rolesService.isAdmin(user), usingFeature(FeatureFlag_1.FeatureFlag.StylePermission), usingFeature(FeatureFlag_1.FeatureFlag.AdvancedStyleEditor));
        },
        modal: maker(require("@CommonFrontend/Modal/ModalService").default),
        uploadStore: function (uploadService) {
            return new UploadStore_1.default(uploadService);
        },
        uploadService: function (apiBaseUrl, modal) {
            return new UploadService_1.default(apiBaseUrl, modal);
        },
        projectApiService: maker(require("Project/ProjectApiService").default),
        pageResourceApiService: function (apiBaseUrl) {
            return new PageResourceApiService_1.PageResourceApiService(apiBaseUrl);
        },
        rootDataStore: function (usingFeature, teamsService, apiBaseUrl, user, userList, projectTags, telemetry, accountService, imageResourceApiService, $rootScope, $timeout) {
            return new RootDataStore_1.RootDataStore(usingFeature, teamsService, apiBaseUrl, user, userList, projectTags, telemetry, accountService, imageResourceApiService, $rootScope, $timeout);
        },
        inviteNewUserModal: function (invoke, rootDataStore, seatsService, modal, serverTelemetry) {
            return new InviteNewUserModal_1.InviteNewUserModal(invoke, rootDataStore, seatsService, modal, serverTelemetry);
        },
        imageLocation: require("./ImageLocation").imageLocation,
        savedBlockApiService: maker(require("SavedBlock/SavedBlockApiService").SavedBlockApiService),
        savedBlockDataStore: maker(require("SavedBlock/SavedBlockDataStore").SavedBlockDataStore),
        savedBlockService: maker(require("SavedBlock/SavedBlockService").default),
        accessTokensApiService: maker(require("SettingsAngular/ApiSettings/AccessTokensPanel/AccessTokensApiService").default),
        acceptTelemetry: maker(require("Project/Modules/Accept/AcceptTelemetry").default),
        editorDebugStore: maker(require("Project/QwilrEditor/EditorDebugStore/EditorDebugStore").EditorDebugStore),
        discoverStore: maker(require("Discover/DiscoverStore").default),
        tourState: tourState,
        tourOrchestrator: maker(require("Onboarding/Tour/TourOrchestrator/TourOrchestrator").TourOrchestrator),
        createAndEditTour: maker(require("Onboarding/Tour/Steps/CreateAndEditTour").default),
        automationHubspotTour: maker(require("Onboarding/Tour/Steps/AutomationHubspotTour").default),
    };
    injectables = lodash_1.default.assign(injectables, require("@CommonFrontendBackend/FeatureFlags/FeatureSet"), require("SettingsAngular/Subscription/SubscriptionControls").default);
    return injectables;
};
